var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.507812 18.3164C0.605469 19.2617 1.40234 20 2.375 20H6.125H18.625C19.6602 20 20.5 19.1602 20.5 18.125V14.375C20.5 13.3398 19.6602 12.5 18.625 12.5H16.75V15.625C16.75 15.9688 16.4688 16.25 16.125 16.25C15.7812 16.25 15.5 15.9688 15.5 15.625V12.5H13V15.625C13 15.9688 12.7188 16.25 12.375 16.25C12.0312 16.25 11.75 15.9688 11.75 15.625V12.5H9.25V15.625C9.25 15.9688 8.96875 16.25 8.625 16.25C8.28125 16.25 8 15.9688 8 15.625V12.5H4.875C4.53125 12.5 4.25 12.2188 4.25 11.875C4.25 11.5312 4.53125 11.25 4.875 11.25H8V8.75H4.875C4.53125 8.75 4.25 8.46875 4.25 8.125C4.25 7.78125 4.53125 7.5 4.875 7.5H8V5H4.875C4.53125 5 4.25 4.71875 4.25 4.375C4.25 4.03125 4.53125 3.75 4.875 3.75H8V1.875C8 0.839844 7.16016 0 6.125 0H2.375C1.33984 0 0.5 0.839844 0.5 1.875V14.375V18.125C0.5 18.1914 0.503906 18.2539 0.507812 18.3164Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSize);
export default __webpack_public_path__ + "static/media/icon-size.fbf0162e25534608e3d121047c548e05.svg";
export { ForwardRef as ReactComponent };